export default {"src":"/_next/static/media/digitalproduct-3.1aa29720.svg","height":97,"width":242,"blurWidth":0,"blurHeight":0};